import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

// useState that remembers its value in this browser, per signed-in user
export function usePersistedState(name, initial) {
  const { user } = useAuth();
  const key = `mokora:${user?.id || "anon"}:${name}`;
  const [value, setValue] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw === null ? initial : JSON.parse(raw);
    } catch {
      return initial;
    }
  });
  useEffect(() => {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* storage unavailable */ }
  }, [key, value]);
  return [value, setValue];
}
